"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrintServicesForOutputType = exports.getPrintServiceIdsForOutputType = exports.canPrint = exports.getPrintingService = void 0;
const DownloadPrintService_1 = __importDefault(require("./other/DownloadPrintService"));
const WalgreensPrintService_1 = __importDefault(require("./walgreens/WalgreensPrintService"));
const StickersPrintService_1 = __importDefault(require("./stickers/StickersPrintService"));
const PrintServiceIds_1 = require("./PrintServiceIds");
const core_1 = require("@mapmaker/core");
const PRINTING_SERVICE_MAP = {
    [PrintServiceIds_1.MapmakerPrintServiceId.DOWNLOAD]: DownloadPrintService_1.default,
    [PrintServiceIds_1.MapmakerPrintServiceId.WALGREENS]: WalgreensPrintService_1.default,
    [PrintServiceIds_1.MapmakerPrintServiceId.STICKERS]: StickersPrintService_1.default,
};
function getPrintingService(serviceId) {
    if (serviceId in PRINTING_SERVICE_MAP) {
        return PRINTING_SERVICE_MAP[serviceId];
    }
    else {
        return null;
    }
}
exports.getPrintingService = getPrintingService;
/**
 * Used to filter out some print services on the fly if we're not ready for them.
 */
function canPrint(printServiceId, design) {
    if (printServiceId === PrintServiceIds_1.MapmakerPrintServiceId.STICKERS) {
        if (design.businessId === "tbl") {
            if ((0, core_1.getFeaturesList)(design, "OPENING").length <= 1) {
                // Single opening designs for TBL do not have any graphics on the background to place the
                // stickers.
                return false;
            }
        }
    }
    return true;
}
exports.canPrint = canPrint;
const OutputTypePrintServices = {
    MATBOARD_WALL_MAP: [
        PrintServiceIds_1.MapmakerPrintServiceId.STICKERS,
        PrintServiceIds_1.MapmakerPrintServiceId.WALGREENS,
        PrintServiceIds_1.MapmakerPrintServiceId.DOWNLOAD,
    ],
    MATBOARD_WALL_MAP_SINGLE: [
        PrintServiceIds_1.MapmakerPrintServiceId.WALGREENS,
        PrintServiceIds_1.MapmakerPrintServiceId.DOWNLOAD,
    ],
    VEHICLE_MAP: [PrintServiceIds_1.MapmakerPrintServiceId.STICKERS],
    VINYL_WALL_MAP: [
        PrintServiceIds_1.MapmakerPrintServiceId.STICKERS,
        PrintServiceIds_1.MapmakerPrintServiceId.DOWNLOAD,
    ],
};
function getPrintServiceIdsForOutputType(outputType) {
    return OutputTypePrintServices[outputType];
}
exports.getPrintServiceIdsForOutputType = getPrintServiceIdsForOutputType;
function getPrintServicesForOutputType(outputType) {
    return getPrintServiceIdsForOutputType(outputType).map(id => getPrintingService(id));
}
exports.getPrintServicesForOutputType = getPrintServicesForOutputType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJpbnRTZXJ2aWNlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3ByaW50aW5nL1ByaW50U2VydmljZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsd0ZBQWdFO0FBQ2hFLDhGQUFzRTtBQUN0RSwyRkFBbUU7QUFFbkUsdURBQTJEO0FBRzNELHlDQUFpRDtBQWNqRCxNQUFNLG9CQUFvQixHQUFHO0lBQzNCLENBQUMsd0NBQXNCLENBQUMsUUFBUSxDQUFDLEVBQUUsOEJBQW9CO0lBQ3ZELENBQUMsd0NBQXNCLENBQUMsU0FBUyxDQUFDLEVBQUUsK0JBQXFCO0lBQ3pELENBQUMsd0NBQXNCLENBQUMsUUFBUSxDQUFDLEVBQUUsOEJBQW9CO0NBQ3hELENBQUM7QUFFRixTQUFnQixrQkFBa0IsQ0FDaEMsU0FBaUM7SUFFakMsSUFBSSxTQUFTLElBQUksb0JBQW9CLEVBQUU7UUFDckMsT0FBTyxvQkFBb0IsQ0FBQyxTQUFTLENBQUMsQ0FBQztLQUN4QztTQUFNO1FBQ0wsT0FBTyxJQUFJLENBQUM7S0FDYjtBQUNILENBQUM7QUFSRCxnREFRQztBQUVEOztHQUVHO0FBQ0gsU0FBZ0IsUUFBUSxDQUN0QixjQUFzQyxFQUN0QyxNQUF1RDtJQUV2RCxJQUFJLGNBQWMsS0FBSyx3Q0FBc0IsQ0FBQyxRQUFRLEVBQUU7UUFDdEQsSUFBSSxNQUFNLENBQUMsVUFBVSxLQUFLLEtBQUssRUFBRTtZQUMvQixJQUFJLElBQUEsc0JBQWUsRUFBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLENBQUMsTUFBTSxJQUFJLENBQUMsRUFBRTtnQkFDbEQseUZBQXlGO2dCQUN6RixZQUFZO2dCQUNaLE9BQU8sS0FBSyxDQUFDO2FBQ2Q7U0FDRjtLQUNGO0lBQ0QsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDO0FBZEQsNEJBY0M7QUFFRCxNQUFNLHVCQUF1QixHQUd6QjtJQUNGLGlCQUFpQixFQUFFO1FBQ2pCLHdDQUFzQixDQUFDLFFBQVE7UUFDL0Isd0NBQXNCLENBQUMsU0FBUztRQUNoQyx3Q0FBc0IsQ0FBQyxRQUFRO0tBQ2hDO0lBQ0Qsd0JBQXdCLEVBQUU7UUFDeEIsd0NBQXNCLENBQUMsU0FBUztRQUNoQyx3Q0FBc0IsQ0FBQyxRQUFRO0tBQ2hDO0lBQ0QsV0FBVyxFQUFFLENBQUMsd0NBQXNCLENBQUMsUUFBUSxDQUFDO0lBQzlDLGNBQWMsRUFBRTtRQUNkLHdDQUFzQixDQUFDLFFBQVE7UUFDL0Isd0NBQXNCLENBQUMsUUFBUTtLQUNoQztDQUNGLENBQUM7QUFFRixTQUFnQiwrQkFBK0IsQ0FDN0MsVUFBNkI7SUFFN0IsT0FBTyx1QkFBdUIsQ0FBQyxVQUFVLENBQUMsQ0FBQztBQUM3QyxDQUFDO0FBSkQsMEVBSUM7QUFFRCxTQUFnQiw2QkFBNkIsQ0FDM0MsVUFBNkI7SUFFN0IsT0FBTywrQkFBK0IsQ0FBQyxVQUFVLENBQUMsQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FDMUQsa0JBQWtCLENBQUMsRUFBRSxDQUFDLENBQ3ZCLENBQUM7QUFDSixDQUFDO0FBTkQsc0VBTUMifQ==